<template>
  <vx-card>
    <form-document-detail :id="id"></form-document-detail>

    <div class="flex flex-row justify-end gap-4">
      <b-button @click="goBack" variant="outline-secondary">Voltar</b-button>
    </div>
  </vx-card>
</template>

<script>

import {
  BForm,
  BFormGroup,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import DocumentService from '@/services/api/DocumentService'

import FormDocumentDetail from './FormDocumentDetail.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BForm,
    BFormGroup,
    BButton,
    FormDocumentDetail
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    service: null,
  }),
  methods: {
    goBack() {
      this.$router.push({
        name: 'document-consult-index'
      })
    },
  },
  computed: {

  },
  beforeMount() {
    this.service = DocumentService.build(this.$vs)
  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
